<template>
    <div>
        
        <div class="new_cases_box">
            <HomeAroundVue></HomeAroundVue>
        </div>
        <div class="plugin_content">
            <div class="box1_right_search">
                <PageSearch :title="pageSearchTitle" :placeholder="pageSearchPlaceholder" @update:value="onCheckPlugin">
                </PageSearch>
            </div>
        </div>

        <!-- <div class="ai_feed ss">
            <feedVue></feedVue>

            <img src="../assets/images/ai/icon_d.png" alt="" class="feed_icon_d">
        </div> -->

     <!--   <div class="ai_feed">
            <div class="feed_content">
                <p>Partners Testimonials</p>
                <p>This widget integrates seamlessly into our website without writing a single line of code,
                    significantly
                    cutting down our development time and expenses. Furthermore, it offers on-demand assistance to our
                    customers across various devices, ensuring that no matter what device they're using, help is always
                    just
                    a moment away. Kneopen Publishing Editor丨Emily</p>
            </div>
        </div> -->
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { dealRouterPath } from "./widget/data"
import PageSearch from "@/components/pageSearch/index.vue"
import HomeAroundVue from "./homeAround.vue"
import feedVue from "@/views/ai/feed.vue"

export default {
    components: {
        HomeAroundVue,
        feedVue,
        PageSearch
    },
    data() {
        return {
            pageSearchTitle: "Check if a journal code is integrated?",
            pageSearchPlaceholder: "Search ISSN or Journal name",
        }
    },
    computed: {
        ...mapGetters(['getJournalData', 'getJourSearchParams']),
    },
    methods: {
        ...mapActions(['fetchJournalData']),
        async onCheckPlugin(inputValue) {
            // 重置条件
            const params = { page: 1, pageSize: this.getJourSearchParams.pageSize, commonCondition: inputValue, journalName: '', publisherName: "" }
            delete this.getJourSearchParams.desc;
            delete this.getJourSearchParams.asc;

            this.$store.commit('setJourSearchParams', params);

            const router = this.$router
            const route = this.$route

            await this.fetchJournalData(this.params);

            dealRouterPath(route.path, this.getJournalData.total, router, params)
        }
    }
}
</script>

<style lang='scss' scoped>
@import "../assets/css/minix.scss";

.new_cases_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;

}

.plugin_content {
    padding: 200px 0;
    width: 100%;
    background-image: url('../assets/images/home/ai_search.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center
}

.box1_right_search {
    @include responsive-width(1200px);
    margin: 0 auto;
}

// .ai_feed {
//     margin-top: 100px;
//     position: relative;

//     .feed_icon_d {
//         position: absolute;
//         top: -44px;
//         right: 20%;
//     }
// 

.ai_feed {
    margin-top: -10px;
    padding: 37px 0;
    background: #189EAE;
    border-radius: 12px 12px 0px 0px;

    .feed_content {
        @include responsive-width(1200px);
        margin: 0 auto;
        color: #fff;
        line-height: 30px;
        font-size: 18px;
        font-weight: 400;
    }

}

@media screen and (max-width: 768px) {
    .ai_feed {
        position: relative;

        .feed_icon_d {
            width: 50px;
            top: -5%;
            right: 7%;
        }
    }

    .plugin_content {
        padding: 100px 0;
    }
}
</style>